export default __webpack_public_path__ + "static/papc-presentation-d7c62d216844e4ddca0a29d96ceb3264.png";